/**
 * Insere bibliotecas nos objetos HTML
 *
 * @author Wellington Pereira
 * @since 2018-10-03
 * @version 2.0.0
 * @license Comercial
 * @class
 */
const htmlElement = {
  /**
   * zIndex do Dialog
   *
   * @property {integer} dialogIndex
   */
  dialogIndex: 101,

  /**
   * Adiciona uma ou mais classes ao elemento
   *
   * @param {string} classes
   */
  addClass(classes) {
    if (classes !== undefined && typeof classes === "string") {
      const cls = classes.split(" ");
      this.classList.add(...cls);
    }
    return this;
  },

  /**
   * Define um efeito para o objeto.
   *
   * @param {string} [effect="fade"] - O efeito a ser aplicado (blind, fade, newspaper, rotate, slide, zoom).
   * @param {string} [io="in"] - A direção do efeito (in, out).
   * @param {string} [direction="left"] - A direção do efeito (left, right, top, bottom).
   * @returns {HTMLElement} Retorna o objeto atual para encadeamento de métodos.
   */
  addEffect(effect = "fade", io = "in", direction = "left") {
    switch (effect) {
      case "fade":
      case "newspaper":
      case "zoom":
        this.addClass(`effect-${effect}-${io}`);
        break;
      default:
        this.addClass(`effect-${effect}-${direction}-${io}`);
    }

    return this;
  },

  /**
   * @description Adiciona um prefixo ao input (span ou button)
   * @version 1.0.0
   */
  addPrefix(options) {
    const addClass = "pfx";
    const append = "before";
    const fieldbox = this.parents(".fieldbox");

    if (options !== undefined) {
      const classname =
        options.class !== undefined && typeof options.class === "string"
          ? `${addClass} ${options.class}`
          : addClass;
      let html;

      if (options.html !== undefined && typeof options.html === "string") {
        html = `<span>${options.html}</span>`;
      } else if (
        options.text !== undefined &&
        typeof options.text === "string"
      ) {
        html = `<span>${options.text}</span>`;
      } else {
        html = "";
      }

      if (typeof options === "object") {
        if (
          options.click !== undefined &&
          typeof options.click === "function"
        ) {
          create({
            element: "button",
            type: "button",
            parent: this,
            append: append,
            class: classname,
            style: options.style,
            html: html,
            icon: options.icon,
            mode: options.mode,
            click: options.click,
          });
        } else {
          create({
            element: "span",
            parent: this,
            append: append,
            class: classname,
            style: options.style,
            html: html,
            icon: options.icon,
          });
        }
      } else {
        create({
          element: "span",
          parent: this,
          append: append,
          class: classname,
          html: html,
        });
      }
    }
  },

  /**
   * @description Adiciona um sufixo ao input (span ou button)
   * @version 1.0.0
   */
  addSuffix(options) {
    const elem = this;
    const addClass = "sfx";
    const append = "after";
    const fieldbox = elem.parents(".fieldbox");

    if (options !== undefined) {
      const classname =
        options.class !== undefined && typeof options.class === "string"
          ? `${addClass} ${options.class}`
          : addClass;
      let html;

      if (options.html !== undefined && typeof options.html === "string") {
        html = options.html;
      } else if (
        options.text !== undefined &&
        typeof options.text === "string"
      ) {
        html = `<span>${options.text}</span>`;
      } else {
        html = "";
      }

      if (typeof options === "object") {
        if (
          options.click !== undefined &&
          typeof options.click === "function"
        ) {
          create({
            element: "button",
            type: "button",
            parent: this,
            append: append,
            class: classname,
            style: options.style,
            html: html,
            icon: options.icon,
            mode: options.mode,
            click: options.click,
          });
        } else {
          create({
            element: "span",
            parent: this,
            append: append,
            class: classname,
            style: options.style,
            text: options.text,
            html: html,
            icon: options.icon,
          });
        }
      } else {
        create({
          element: "span",
          parent: this,
          append: append,
          class: classname,
          html: html,
        });
      }
    }
  },

  /**
   * Adiciona um estilo a uma pseudo-propriedade
   *
   * @param {string} pseudo
   * @param {object} style
   */
  addPseudoStyle(pseudo, style) {
    let id = this.id;
    let sheetId = "pseudoStyles";
    let head = document.getElementsByTagName("head")[0];
    let sheet = document.getElementById(sheetId);
    let html;

    if (sheet === null || sheet === undefined) {
      sheet = document.createElement("style");
      sheet.id = sheetId;
      sheet.setAttribute("type", "text/css");
      sheet.setAttribute("rel", "stylesheet");
    }

    html = sheet.innerHTML;

    if (html === undefined) {
      html =
        " #" +
        id +
        "::" +
        pseudo +
        JSON.stringify(style).replace(/,/g, ";").replace(/"/g, "");
    } else {
      html +=
        " #" +
        id +
        "::" +
        pseudo +
        JSON.stringify(style).replace(/,/g, ";").replace(/"/g, "");
    }

    sheet.innerHTML = html;
    head.append(sheet);
    return this;
  },

  /**
   * Define ou recupera um atributo de Aria
   *
   * @param {string} name
   * @param {any} value
   * @returns {any}
   */
  aria(name, value = null) {
    if (value === null) {
      return this.getAttribute(`aria-${name}`);
    } else {
      this.setAttribute(`aria-${name}`, value);
      return value;
    }
  },

  /**
   * Adiciona uma ou mais classes ao elemento
   *
   * @param {(string | object)} css
   */
  css(css) {
    if (css !== undefined && typeof css === "string") {
      const arrCss = css.split(";");
      for (const i in arrCss) {
        if (typeof arrCss[i] === "string") {
          const newCss = arrCss[i].split(":");
          this.style[newCss[0].trim()] = newCss[1].trim();
        }
      }
    } else if (css !== undefined && typeof css === "object") {
      for (const key in css) {
        this.style[key] = css[key];
      }
    }
    return this;
  },

  /**
   * Retorna um cloen do objeto
   */
  clone() {
    return this.cloneNode(true);
  },

  /**
   * Define ou recupera um atributo de Aria
   *
   * @param {string} name
   * @param {any} value
   * @returns {any}
   */
  data(key, value) {
    if (value === false) {
      value = "false";
    }

    if (!value) {
      return this.dataset[key];
    } else {
      this.dataset[key] = value;
      return value;
    }
  },

  /**
   * Transforma o elemento em uma caixa de diálogo
   *
   * @param {object} options
   * @param {string} [options.title] Título do diálogo
   * @param {boolean} [options.modal=true] Mantido por compatibilidade; todo diálogo recebe overlay
   * @param {(boolean|string)} [options.effect="zoom"] Define o efeito de abertura ( false | blind | fade | newspaper | rotate-y | rotate-x | slide-top | slide-right | slide-bottom | slide-left | zoom )
   * @param {string} [options.variant] Variante visual do diálogo ( drawer )
   * @param {'workspace'|'content'|'application'} [options.scope='workspace'] Região do shell bloqueada pelo diálogo.
   * @param {string} [options.placement="right"] Lado de abertura da variante drawer ( right | left )
   * @param {object} [options.class] Classe CSS do diálogo
   * @param {object} [options.style] Estilo CSS do diálogo
   * @param {function} [options.open] Função que será executada ao abrir o diálogo
   * @param {function} [options.close] Função que será executada ao fechar o diálogo
   * @param {boolean} [options.kill] Define se o diálogo será destruído ao fechar
   */
  dialog(options) {
    const elem = this;

    const resolveScope = (dialogOptions = {}) => {
      const requestedScope = ['workspace', 'content', 'application'].includes(dialogOptions.scope)
        ? dialogOptions.scope
        : 'workspace';
      const shell = (name) => document.querySelector(`[data-ep-shell-region="${name}"]`);
      const origin = elem.parentElement;
      const workspace = shell('workspace');
      const contextualAside = shell('contextual-aside');
      if (dialogOptions.scope === undefined) {
        const openDialogs = Array.from(document.querySelectorAll('.dialog.show'));
        const activeDialog = openDialogs.reduce((top, item) => (
          !top || Number(item.style.zIndex) > Number(top.style.zIndex) ? item : top
        ), null);
        if (activeDialog?._overlayScope) return activeDialog._overlayScope;
      }

      if (requestedScope === 'application') {
        return { name: 'application', container: document.body, regions: [document.body] };
      }
      if (requestedScope === 'content') {
        if (workspace && contextualAside) {
          return { name: 'content', container: workspace, regions: [workspace, contextualAside] };
        }
        if (workspace) {
          return { name: 'workspace', container: workspace, regions: [workspace] };
        }
      }
      if (requestedScope === 'workspace' && dialogOptions.scope === 'workspace' && workspace) {
        return { name: 'workspace', container: workspace, regions: [workspace] };
      }
      if (workspace && (origin === workspace || workspace.contains(origin))) {
        return { name: 'workspace', container: workspace, regions: [workspace] };
      }
      // A page without the EP logged shell (or an explicitly body mounted
      // dialog) keeps a usable application level modal as a safe fallback.
      return { name: 'application', container: document.body, regions: [document.body] };
    };

    const getScopeRect = (scope) => {
      if (scope.name === 'application') {
        return { top: 0, left: 0, right: window.innerWidth, bottom: window.innerHeight };
      }
      const rects = scope.regions
        .filter((region) => region?.isConnected)
        .map((region) => region.getBoundingClientRect());
      if (!rects.length) return { top: 0, left: 0, right: window.innerWidth, bottom: window.innerHeight };
      return {
        top: Math.min(...rects.map((rect) => rect.top)),
        left: Math.min(...rects.map((rect) => rect.left)),
        right: Math.max(...rects.map((rect) => rect.right)),
        bottom: Math.max(...rects.map((rect) => rect.bottom)),
      };
    };

    const isDrawerDialog = (dialog) => dialog?.classList?.contains("dialog-drawer");

    const getViewportOffsets = (dialog) => {
      const scope = dialog?._overlayScope || { name: 'application', regions: [document.body] };
      const rect = getScopeRect(scope);
      return { top: rect.top, bottom: Math.max(window.innerHeight - rect.bottom, 0), left: rect.left, right: Math.max(window.innerWidth - rect.right, 0), rect };
    };

    const positionOverlay = (dialog) => {
      const overlay = dialog?._overlay;
      if (!overlay) return;
      const { top, left, rect } = getViewportOffsets(dialog);
      overlay.style.top = `${top}px`;
      overlay.style.left = `${left}px`;
      overlay.style.width = `${Math.max(rect.right - rect.left, 0)}px`;
      overlay.style.height = `${Math.max(rect.bottom - rect.top, 0)}px`;
    };

    const centerDialog = (onPositioned) => {
      requestAnimationFrame(() => {
        const parents = elem.parents(".dialog");
        if (!parents || !parents[0]) return;
        let dialog = parents[0];
        if (!dialog.classList.contains('show')) return;
        dialog._instance = this;
        positionOverlay(dialog);

        // Se ainda não renderizou tamanho (ex.: dom ainda montando), tenta novamente no próximo frame
        if (!dialog.clientWidth || !dialog.clientHeight) {
          centerDialog(onPositioned);
          return;
        }

        const minVerticalMargin = 24;
        const minHorizontalMargin = 24;
        const { top: topOffset, bottom: bottomOffset, left: leftOffset, right: rightOffset } = getViewportOffsets(dialog);
        const availableHeight = Math.max(window.innerHeight - topOffset - bottomOffset, 0);
        const content = dialog.querySelector(':scope > .dialog-content');
        if (content) content.style.removeProperty('max-height');

        // O diálogo precisa caber na área útil real da aplicação. Grids e abas
        // podem aumentar sua altura depois da abertura, portanto a restrição é
        // reaplicada em toda centralização.
        const maxDialogHeight = Math.max(
          availableHeight - (minVerticalMargin * 2),
          136
        );
        dialog.style.maxHeight = `${maxDialogHeight}px`;
        // Grupos de abas dimensionam-se pelo limite do diálogo (aba que passa disso rola por dentro).
        dialog.querySelectorAll('.tab-group').forEach((group) => group.dispatchEvent(new CustomEvent('ep:tab-layout-sync')));

        const availableWidth = Math.max(window.innerWidth - leftOffset - rightOffset, 0);
        const maxDialogWidth = Math.max(availableWidth - (minHorizontalMargin * 2), 0);
        const computedMinWidth = Number.parseFloat(getComputedStyle(dialog).minWidth) || 0;
        dialog.style.maxWidth = `${maxDialogWidth}px`;
        dialog.style.minWidth = maxDialogWidth < computedMinWidth ? `${maxDialogWidth}px` : '';
        const left = leftOffset + (availableWidth - dialog.clientWidth) / 2;
        const dialogHeight = dialog.clientHeight;
        // Centro geométrico puro (razão 0.5) deixa o diálogo com aparência
        // pesada na metade inferior. Um pequeno viés óptico para cima aproxima
        // o resultado do centro percebido, sem virar offset fixo em pixels:
        // a folga (availableHeight - dialogHeight) é distribuída de forma
        // assimétrica, então o efeito desaparece naturalmente quando o
        // diálogo já ocupa quase toda a altura disponível.
        const opticalCenterRatio = 0.4;
        const desiredTop = topOffset + (availableHeight - dialogHeight) * opticalCenterRatio;

        const minTop = Math.max(topOffset + minVerticalMargin, 0);
        const maxTop = Math.max(window.innerHeight - bottomOffset - dialogHeight - minVerticalMargin, minTop);
        const minLeft = Math.max(leftOffset + minHorizontalMargin, 0);
        const maxLeft = Math.max(window.innerWidth - rightOffset - dialog.clientWidth - minHorizontalMargin, minLeft);

        const top = Math.min(Math.max(desiredTop, minTop), maxTop);

        dialog.style.left = `${Math.min(Math.max(left, minLeft), maxLeft)}px`;
        dialog.style.top = `${top}px`;
        dialog._lastCenteredHeight = dialogHeight;
        onPositioned?.();
      });
    };

    const positionDrawer = (dialog, onPositioned) => {
      requestAnimationFrame(() => {
        if (!dialog || !dialog.classList.contains('show')) return;
        dialog._instance = this;

        const { top: topOffset, bottom: bottomOffset, left: leftOffset, right: rightOffset } = getViewportOffsets(dialog);
        const isLeft = dialog.classList.contains("dialog-drawer-left");
        const availableWidth = Math.max(window.innerWidth - leftOffset - rightOffset, 0);

        dialog.style.top = `${topOffset}px`;
        dialog.style.bottom = `${bottomOffset}px`;
        dialog.style.height = "auto";
        dialog.style.maxHeight = "none";
        dialog.style.maxWidth = `${availableWidth}px`;
        dialog.style.left = isLeft ? `${leftOffset}px` : "auto";
        dialog.style.right = isLeft ? "auto" : `${rightOffset}px`;
        onPositioned?.();
      });
    };

    const positionDialog = (dialog, onPositioned) => {
      positionOverlay(dialog);
      if (isDrawerDialog(dialog)) {
        positionDrawer(dialog, onPositioned);
        return;
      }
      centerDialog(onPositioned);
    };

    const lockNaturalDialogWidth = (dialog, options = {}) => {
      if (!dialog) return;

      if (isDrawerDialog(dialog)) {
        const drawerWidth = typeof options.width === "number"
          ? `${options.width}px`
          : options.width;
        if (typeof drawerWidth === "string" && drawerWidth.trim().length > 0) {
          dialog.style.setProperty("--dialog-drawer-width", drawerWidth.trim());
        }
        dialog.style.removeProperty("width");
        dialog.style.removeProperty("min-width");
        dialog.style.removeProperty("max-width");
        return;
      }

      if (options.autoform !== true) return;

      const { left, right } = getViewportOffsets(dialog);
      const viewportWidth = Math.max(window.innerWidth - left - right - 48, 0);
      const viewportMaxWidth = `${viewportWidth}px`;
      // `auto` mantém o layout inicial do formulário, mas não é uma largura
      // que possa ser travada no diálogo: nesse caso a largura passa a seguir
      // o conteúdo do editor a cada tecla. Só comprimentos CSS reais entram
      // no caminho de largura explícita.
      const isCssLength = (value) => (
        typeof value === 'string'
        && value.trim().length > 0
        && value.trim().toLowerCase() !== 'auto'
      );
      const explicitWidth = Number(options.width);
      const explicitMinWidth = Number(options.minWidth);
      const explicitMaxWidth = Number(options.maxWidth);
      const explicitWidthCss = isCssLength(options.width) ? options.width.trim() : null;
      const explicitMinWidthCss = isCssLength(options.minWidth) ? options.minWidth.trim() : null;
      const explicitMaxWidthCss = isCssLength(options.maxWidth) ? options.maxWidth.trim() : null;

      if (explicitWidthCss || explicitMinWidthCss || explicitMaxWidthCss) {
        if (explicitWidthCss) {
          dialog.style.width = explicitWidthCss;
        }
        if (explicitWidthCss || explicitMaxWidthCss) {
          dialog.style.maxWidth = explicitMaxWidthCss || viewportMaxWidth;
        }
        if (explicitMinWidthCss) {
          dialog.style.minWidth = explicitMinWidthCss;
        }
        return;
      }

      const maxWidth = Number.isFinite(explicitMaxWidth) && explicitMaxWidth > 0
        ? Math.min(explicitMaxWidth, viewportWidth)
        : viewportWidth;
      const minWidth = Number.isFinite(explicitMinWidth) && explicitMinWidth > 0
        ? Math.min(explicitMinWidth, maxWidth)
        : 0;
      const widthAllowance = 24;
      const measuredWidth = Math.ceil(dialog.getBoundingClientRect().width || dialog.clientWidth || 0);
      if (!measuredWidth && !(Number.isFinite(explicitWidth) && explicitWidth > 0)) return;

      if (Number.isFinite(explicitWidth) && explicitWidth > 0) {
        dialog._naturalWidth = explicitWidth;
      } else if (!dialog._naturalWidth) {
        dialog._naturalWidth = measuredWidth + widthAllowance;
      }

      const width = Math.min(Math.max(dialog._naturalWidth, minWidth), maxWidth);
      dialog.style.width = `${width}px`;
      dialog.style.maxWidth = `${maxWidth}px`;
      if (minWidth > 0) {
        dialog.style.minWidth = `${minWidth}px`;
      }
    };

    const addResizeListener = (dialog) => {
      if (typeof window === 'undefined' || !dialog) return;
      if (dialog._resizeHandler) return;
      dialog._resizeHandler = () => {
        lockNaturalDialogWidth(dialog, dialog._dialogOptions || {});
        positionDialog(dialog);
      };
      window.addEventListener('resize', dialog._resizeHandler);
      if (typeof ResizeObserver === 'function') {
        dialog._scopeResizeObserver = new ResizeObserver(() => positionDialog(dialog));
        dialog._overlayScope?.regions?.forEach((region) => dialog._scopeResizeObserver.observe(region));
      }
    };

    const removeResizeListener = (dialog) => {
      if (typeof window === 'undefined' || !dialog || !dialog._resizeHandler) return;
      window.removeEventListener('resize', dialog._resizeHandler);
      delete dialog._resizeHandler;
      dialog._scopeResizeObserver?.disconnect();
      delete dialog._scopeResizeObserver;
    };

    const addContentResizeObserver = (dialog) => {
      if (typeof ResizeObserver !== 'function' || !dialog || dialog._contentResizeObserver) return;
      dialog._contentResizeObserver = new ResizeObserver(() => {
        if (!dialog.isConnected || !dialog.classList.contains('show')) return;
        if (dialog.classList.contains('dragging')) return;
        if (isDrawerDialog(dialog)) return;
        const top = Number.parseFloat(dialog.style.top);
        if (!Number.isFinite(top)) return;
        const { top: topOffset, bottom: bottomOffset } = getViewportOffsets(dialog);
        dialog.style.maxHeight = `${Math.max(window.innerHeight - topOffset - bottomOffset - 48, 136)}px`;
        // Diálogo que mudou de tamanho e não foi movido pelo usuário volta a ficar centralizado.
        const height = dialog.clientHeight;
        if (dialog._lastCenteredHeight !== undefined && height !== dialog._lastCenteredHeight && !dialog._movedByUser) {
          dialog._lastCenteredHeight = height;
          centerDialog();
        }
      });
      dialog._contentResizeObserver.observe(dialog);
    };

    const removeContentResizeObserver = (dialog) => {
      dialog?._contentResizeObserver?.disconnect?.();
      delete dialog?._contentResizeObserver;
    };

    const fns = {
      create: (options) => {
        elem.kill = options.kill === true ? true : false;
        let overlay = null;

        const scope = resolveScope(options);
        overlay = document.createElement("div");
        if (elem.id !== undefined && elem.id.length > 0) {
          overlay.id = `${elem.id}-overlay`;
        }

        overlay.classList.add("overlay", "dialog-overlay");
        overlay.dataset.scope = scope.name;
        overlay.style.visibility = "collapse";

        if (options.effect !== false) {
          switch (options.effect) {
            case "basic":
            case "fast-fade":
            case "blink":
              overlay.classList.add("effect-fast-fade");
              break;
            default:
              overlay.classList.add("effect-fade");
              break;
          }
        }
        scope.container.append(overlay);

        const dialog = document.createElement("div");
        dialog._overlay = overlay;
        dialog._overlayScope = scope;

        if (elem.id !== undefined && elem.id.length > 0) {
          dialog.id = `${elem.id}-dialog`;
        }

        dialog.classList.add("dialog");
        dialog.dataset.scope = scope.name;
        dialog._dialogOptions = options;

        if (options.variant === "drawer") {
          const placement = options.placement === "left" ? "left" : "right";
          const drawerWidth = typeof options.width === "number"
            ? `${options.width}px`
            : options.width;
          dialog.classList.add("dialog-drawer", `dialog-drawer-${placement}`);
          if (typeof drawerWidth === "string" && drawerWidth.trim().length > 0) {
            dialog.style.setProperty("--dialog-drawer-width", drawerWidth.trim());
          }
        }

        if (options.class !== undefined && typeof options.class === "string") {
          let classes = options.class.split(" ");
          for (let c = 0; c < classes.length; c++) {
            if (/[A-Za-z0-9]/.test(classes[c])) {
              dialog.classList.add(classes[c]);
            }
          }
        }

        if (options.effect === undefined) {
          options.effect = "zoom";
        }

        if (options.effect !== false) {
          switch (options.effect) {
            case "basic":
              options.time = 150;
              break;
            case "fast-fade":
              options.time = 200;
              break;
            case "blink":
              options.time = 250;
              break;
            default:
              options.time = 500;
              break;
          }
          dialog.classList.add(`effect-${options.effect}`);
        } else {
          options.time = 0;
        }

        if (options.style === undefined) {
          options.style = {};
        }

        if (
          options.variant !== "drawer" &&
          options.width !== undefined &&
          typeof options.width === "number"
        ) {
          options.style.width = `${options.width}px`;
        }

        if (
          options.height !== undefined &&
          typeof options.height === "number"
        ) {
          options.style.height = `${options.height}px`;
        }

        elem.css(options.style);
        dialog.style.visibility = "collapse";

        scope.container.append(dialog);
        dialog.instance = elem;

        if (options.title !== false) {
          let title = document.createElement("div");

          if (typeof options.title === "string" || typeof options.title === "object") {
            title.classList.add("dialog-title");

            if (typeof options.title === "object") {
              if (
                options.title.icon &&
                typeof options.title.icon === "object" &&
                typeof options.title.icon.type === "string" &&
                typeof options.title.icon.name === "string"
              ) {
                const icon = document.createElement("i");
                icon.classList.add(`fa-${options.title.icon.type}`);
                icon.classList.add(`fa-${options.title.icon.name}`);
                icon.classList.add(`dialog-title-icon`);
                title.append(icon);
              }

              if (typeof options.title.text === "string" && options.title.text.length > 0) {
                const text = document.createElement("span");
                text.textContent = options.title.text;
                title.append(text);
              }
            }
            else if (typeof options.title === "string" && options.title.length > 0) {
              title.textContent = options.title;
            } else {
              title.textContent = "";
            }
          }
          dialog.append(title);

          if (options.close !== false) {
            const close = document.createElement("button");
            const closeIcon = document.createElement("i");
            close.type = "button";
            close.classList.add("dialog-close");
            closeIcon.classList.add("fa-solid", "fa-xmark");
            closeIcon.setAttribute("aria-hidden", "true");
            close.setAttribute("aria-label", globalThis?.dic?.labels?.close || "Fechar");
            close.dataset.button = "esc";
            close.addEventListener("click", fns.close);

            if (options.onClose && typeof options.onClose === 'function') {
              close.addEventListener("click", options.onClose);
            }

            close.append(closeIcon);
            title.append(close);
          }

          if (options.draggable) {
            title.onmousedown = (event) => {
              event.preventDefault();

              let shiftX = event.clientX - dialog.getBoundingClientRect().left;
              let shiftY = event.clientY - dialog.getBoundingClientRect().top;
              let isDragging = true;
              dialog.classList.add("dragging");

              const moveAt = (pageX, pageY) => {
                requestAnimationFrame(() => {
                  dialog.style.left = `${pageX - shiftX}px`;
                  dialog.style.top = `${pageY - shiftY}px`;
                });
              };

              const onMouseMove = (event) => {
                if (isDragging) {
                  moveAt(event.pageX, event.pageY);
                }
              };

              document.addEventListener("mousemove", onMouseMove);

              document.onmouseup = () => {
                isDragging = false;
                document.removeEventListener("mousemove", onMouseMove);
                document.onmouseup = null;
                dialog.classList.remove("dragging");
                dialog._movedByUser = true;
              };
            };
          } else {
            const dialogTitle = dialog.querySelector(".dialog-title");
            if (dialogTitle) {
              dialogTitle.style.cursor = "default";
            }
          }

          title.ondragstart = () => false;
        }

        if (
          options.toolbar !== undefined &&
          Array.isArray(options.toolbar) &&
          options.toolbar.length > 0
        ) {
          let toolbar = document.createElement("div");
          toolbar.classList.add("dialog-toolbar");
          dialog.append(toolbar);
        }

        const content = document.createElement("div");
        content.classList.add("dialog-content");
        dialog.append(content);
        content.append(elem);

        requestAnimationFrame(() => {
          content.append(elem);
        });

        if (
          options.buttons &&
          Array.isArray(options.buttons) &&
          options.buttons.length > 0
        ) {
          let buttonbar = document.createElement("div");

          if (options?.buttonbarPosition?.toLowerCase() === "top") {
            content.before(buttonbar);
            buttonbar.classList.add("dialog-top-buttons");
          } else {
            if (options.autoform === true) {
              buttonbar.classList.add("autoform-dialog-buttons");
            } else {
              buttonbar.classList.add("dialog-buttons");
            }

            dialog.append(buttonbar);
          }

          let maxWidth = 0;
          for (let b in options.buttons) {
            options.buttons[b].element = "button";
            options.buttons[b].parent = buttonbar;
            create(options.buttons[b]).then((bt) => {
              if (options.buttons[b].close !== false) {
                bt.addEventListener("click", fns.close);
              }

              if (bt.clientWidth > maxWidth) {
                maxWidth = bt.clientWidth;
              }
            });
          }
          buttonbar.style[
            "grid-template-columns"
          ] = `repeat(${options.buttons.length}, auto)`;
        }

        if (
          options.onClose !== undefined && typeof options.onClose === "function"
        ) {
          elem.onClose = options.onClose;
        }

        if (options.onOpen !== undefined && typeof options.onOpen === "function") {
          elem.onOpen = options.onOpen;
        }

        if (
          content.clientHeight < content.scrollHeight &&
          /firefox/i.test(navigator.userAgent)
        ) {
          let pr = parseInt(
            window
              .getComputedStyle(content, null)
              .getPropertyValue("padding-right")
          );
          content.style.paddingRight = `${pr + 10}px`;
        }

        if (options.autoOpen !== undefined && options.autoOpen === true) {
          fns.open(options.time);
        }
      },

      open: (time = 500) => {
        const parents = elem.parents(".dialog");
        if (!parents || !parents[0]) return; // Verifica se o dialog existe
        let dialog = parents[0];

        if (dialog._closeTimer) {
          clearTimeout(dialog._closeTimer);
          delete dialog._closeTimer;
        }
        if (dialog._closeTransitionHandler) {
          dialog.removeEventListener("transitionend", dialog._closeTransitionHandler);
          delete dialog._closeTransitionHandler;
        }

        let overlay = dialog._overlay;

        const requestedZIndex = Number(dialog._dialogOptions?.zIndex);
        if (Number.isFinite(requestedZIndex)) {
          if (overlay) overlay.style.zIndex = String(requestedZIndex - 1);
          dialog.style.zIndex = String(requestedZIndex);
          htmlElement.dialogIndex = Math.max(htmlElement.dialogIndex, requestedZIndex + 1);
        } else {
          if (overlay) overlay.style.zIndex = htmlElement.dialogIndex++;
          dialog.style.zIndex = htmlElement.dialogIndex++;
        }
        dialog.data("index", htmlElement.dialogIndex - 100);

        // Guarda o foco atual (fora do diálogo) para restaurar ao fechar
        const currentFocus = document.activeElement;
        if (currentFocus && !dialog.contains(currentFocus)) {
          dialog._prevFocus = currentFocus;
        } else {
          dialog._prevFocus = null;
        }

        const focusableSelectors = [
          'a[href]:not([tabindex="-1"])',
          'button:not([disabled]):not([tabindex="-1"])',
          'textarea:not([disabled]):not([tabindex="-1"])',
          'input:not([disabled]):not([tabindex="-1"])',
          'select:not([disabled]):not([tabindex="-1"])',
          '[tabindex]:not([tabindex="-1"])'
        ];

        const getFocusable = () => dialog.querySelectorAll(focusableSelectors.join(","));
        let isRefocusing = false;
        const isTopDialog = () => {
          const shownDialogs = Array.from(document.querySelectorAll('.dialog.show'));
          if (shownDialogs.length === 0) return true;
          const topDialog = shownDialogs.reduce((top, item) => (
            !top || Number(item.style.zIndex) > Number(top.style.zIndex) ? item : top
          ), null);
          return topDialog === dialog;
        };
        const targetBelongsToDialog = (target) => {
          if (!target || !target.isConnected) return false;
          if (dialog.contains(target)) return true;

          const comboPanel = target.closest?.('.combo-options');
          const comboParent = comboPanel?._comboParent || null;
          if (comboParent && dialog.contains(comboParent)) return true;

          const detachedPopup = target.closest?.('.icon-picker-popover, .palette-popover, .calendar');
          const popupOwner = detachedPopup?._epPopupOwner || null;
          return Boolean(popupOwner && dialog.contains(popupOwner));
        };

        const targetIsInsideModalScope = (target) => {
          const scope = dialog._overlayScope;
          if (scope?.name === 'application') return true;
          return (scope?.regions || []).some((region) => region === target || region?.contains?.(target));
        };

        const focusDialog = () => {
          if (isRefocusing) return;
          isRefocusing = true;
          const focusable = getFocusable();
          if (focusable.length) {
            focusable[0].focus();
          } else {
            dialog.focus();
          }
          requestAnimationFrame(() => {
            isRefocusing = false;
          });
        };

        const trapFocus = (event) => {
          if (event.key !== "Tab" || !isTopDialog() || !targetIsInsideModalScope(event.target)) return;
          const focusable = getFocusable();
          if (!focusable.length) return;
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey) {
            if (document.activeElement === first) {
              event.preventDefault();
              last.focus();
            }
          } else {
            if (document.activeElement === last) {
              event.preventDefault();
              first.focus();
            }
          }
        };

        const enforceModal = (event) => {
          if (!isTopDialog()) return;
          if (isRefocusing) return;
          if (!event?.target || !event.target.isConnected) return;
          if (!targetBelongsToDialog(event.target) && targetIsInsideModalScope(event.target)) {
            event.preventDefault();
            focusDialog();
          }
        };

        const enforceModalKeys = (event) => {
          if (!isTopDialog()) return;
          // Bloqueia teclas se o foco estiver fora do diálogo, mas deixa Enter/Esc funcionarem
          if (targetBelongsToDialog(event.target) || !targetIsInsideModalScope(event.target)) return;

          const keyRaw = (event.key || '').toLowerCase();
          const key = keyRaw === 'escape' ? 'esc' : keyRaw;

          // Se existe data-button correspondente dentro do diálogo, deixa o keydown seguir para ser tratado
          const escapedKey = (globalThis.CSS && typeof globalThis.CSS.escape === 'function')
            ? globalThis.CSS.escape(key)
            : String(key || '').replace(/\\/g, '\\\\').replace(/"/g, '\\"');
          const candidate = dialog.querySelector(`[data-button="${escapedKey}"]`);
          if (candidate) {
            // garante que o diálogo tenha o foco, mas não bloqueia a tecla
            focusDialog();
            return;
          }

          event.preventDefault();
          event.stopPropagation();
          focusDialog();
        };

        setTimeout(() => {
          if (overlay) overlay.classList.add("show");
          dialog.classList.add("show");
          refreshDialogInteractionLock();

          if (overlay) overlay.style.visibility = "visible";
          lockNaturalDialogWidth(dialog, dialog._dialogOptions || {});
          // Let conditional groups finish their first layout before measuring.
          // Reveal only after a measurable dialog has actually been centered.
          requestAnimationFrame(() => positionDialog(dialog, () => {
            dialog.style.visibility = "visible";
            addContentResizeObserver(dialog);
            focusDialog();
            if (elem.onOpen) elem.onOpen();
          }));
          addResizeListener(dialog);
          dialog.setAttribute("aria-modal", dialog._overlayScope?.name === "application" ? "true" : "false");
          dialog.setAttribute("role", "dialog");
          dialog._trapHandler = trapFocus;
          dialog._enforceModal = enforceModal;
          dialog._enforceKeys = enforceModalKeys;
          dialog.tabIndex = -1;
          // Se o foco atual não está no diálogo, remove e foca dentro
          if (document.activeElement && !dialog.contains(document.activeElement)) {
            document.activeElement.blur?.();
          }
          document.addEventListener("keydown", trapFocus, true);
          document.addEventListener("focusin", enforceModal, true);
          document.addEventListener("mousedown", enforceModal, true);
          document.addEventListener("touchstart", enforceModal, true);
          document.addEventListener("keydown", enforceModalKeys, true);
        }, time);
      },

      close: (kill = false) => {
        const parents = elem.parents(".dialog");
        if (!parents || !parents[0]) return; // Verifica se o dialog existe
        let dialog = parents[0];

        // Close pode ser acionado por mais de uma camada no mesmo evento
        // (ex.: botão do Dialog + callback do AutoForm). Antes de iniciar um
        // novo fechamento, cancela a finalização anterior para não deixar um
        // timer órfão fechar uma reabertura subsequente.
        if (dialog._closeTimer) {
          clearTimeout(dialog._closeTimer);
          delete dialog._closeTimer;
        }
        if (dialog._closeTransitionHandler) {
          dialog.removeEventListener("transitionend", dialog._closeTransitionHandler);
          delete dialog._closeTransitionHandler;
        }

        const prevFocus = dialog._prevFocus;
        const dialogOptions = dialog._dialogOptions || {};
        const shouldAnimateDrawerClose = (
          isDrawerDialog(dialog)
          && dialogOptions.effect !== false
          && Number(dialogOptions.time) > 0
        );

        let overlay = dialog._overlay;
        removeResizeListener(dialog);
        removeContentResizeObserver(dialog);
        if (dialog._trapHandler) {
          document.removeEventListener("keydown", dialog._trapHandler, true);
          delete dialog._trapHandler;
        }
        if (dialog._enforceModal) {
          document.removeEventListener("focusin", dialog._enforceModal, true);
          document.removeEventListener("mousedown", dialog._enforceModal, true);
          document.removeEventListener("touchstart", dialog._enforceModal, true);
          delete dialog._enforceModal;
        }
        if (dialog._enforceKeys) {
          document.removeEventListener("keydown", dialog._enforceKeys, true);
          delete dialog._enforceKeys;
        }
        delete dialog._naturalWidth;

        dialog.style.zIndex = htmlElement.dialogIndex--;
        if (overlay) overlay.style.zIndex = htmlElement.dialogIndex--;

        if (overlay) overlay.classList.remove("show");
        dialog.classList.remove("show");
        refreshDialogInteractionLock();

        const finalizeClose = () => {
          if (dialog._closeTimer) {
            clearTimeout(dialog._closeTimer);
            delete dialog._closeTimer;
          }
          if (dialog._closeTransitionHandler) {
            dialog.removeEventListener("transitionend", dialog._closeTransitionHandler);
            delete dialog._closeTransitionHandler;
          }

          if (overlay) overlay.style.visibility = "collapse";
          dialog.style.visibility = "collapse";

          if (!isDrawerDialog(dialog)) {
            delete dialog._dialogOptions;
          }

          if (elem.kill || kill === "destroy") {
            requestAnimationFrame(() => {
              fns.destroy();
            });
          }
        };

        if (shouldAnimateDrawerClose) {
          dialog._closeTransitionHandler = (event) => {
            if (event.target !== dialog) return;
            finalizeClose();
          };
          dialog.addEventListener("transitionend", dialog._closeTransitionHandler);
          dialog._closeTimer = setTimeout(
            finalizeClose,
            Number(dialogOptions.time) + 50
          );
        } else {
          finalizeClose();
        }

        // Restaura o foco ao elemento anterior se ainda existir
        if (prevFocus && typeof prevFocus.focus === "function" && prevFocus.isConnected) {
          setTimeout(() => {
            try { prevFocus.focus(); } catch (e) { }
          }, 0);
        }
        dialog._prevFocus = null;
      },

      destroy: () => {
        const parents = elem.parents(".dialog");
        if (!parents || !parents[0]) return;
        let dialog = parents[0];
        let overlay = dialog._overlay;
        removeResizeListener(dialog);
        if (dialog._closeTimer) {
          clearTimeout(dialog._closeTimer);
          delete dialog._closeTimer;
        }
        if (dialog._closeTransitionHandler) {
          dialog.removeEventListener("transitionend", dialog._closeTransitionHandler);
          delete dialog._closeTransitionHandler;
        }

        dialog.remove();
        if (overlay) overlay.remove();
      },
    };

    if (typeof options === "object") {
      fns.create(options);
    } else if (typeof options === "number") {
      fns.open(options);
    } else {
      if (options !== undefined) {
        switch (options) {
          case "close":
            fns.close();
            break;
          case "destroy":
            fns.destroy();
            break;
          case "open":
            fns.open();
            break;
        }
      }
    }
    Object.assign(this, fns);
    return this;
  },

  /**
   * Esvazia o elemento
   */
  empty() {
    this.innerHTML = "";
  },

  /**
   * Define a altura de um elemento
   *
   * @param {(string | number)} [height] Altura do elemento
   * @returns {any} Altura em pixels do elemento
   */
  height(height) {
    if (typeof height === "string") {
      this.style.height = height;
      return this;
    } else if (typeof height === "number") {
      this.style.height = `${parseInt(height.toString())}px`;
      return this;
    } else if (typeof height === undefined) {
      return this.clientHeight;
    }
  },

  /**
   * Oculta o elemento
   */
  hide() {
    this.style.display = "none";
    return this;
  },

  /**
   * Define o html para o elemento
   *
   * @param {string} [html] Conteúdo do elemento
   * @returns {string} Conteúdo do elemento
   */
  html(html) {
    if (typeof html === "string" || typeof html === "number") {
      this.innerHTML = html;
      return this;
    } else if (typeof html === "undefined") {
      return this.innerHTML;
    } else {
      return this;
    }
  },

  /**
   * Busca a lista de parents
   *
   * @param {string} [selector] Traz apenas os parents ccom o seletor selecionado
   */

  parents(selector) {
    let current = this;
    const list = [];

    if (selector) {
      const arr = Array.from(document.querySelectorAll(selector));

      while (
        current &&
        current.parentNode &&
        current.parentNode !== document.documentElement
      ) {
        current = current.parentNode;

        if (arr.includes(current)) {
          list.push(current);
        }
      }
    } else {
      while (
        current &&
        current.parentNode &&
        current.parentNode !== document.documentElement
      ) {
        current = current.parentNode;
        list.push(current);
      }
    }

    return list.length > 0 ? list : null;
  },

  /**
   * Remove uma ou mais classes do elemento
   *
   * @param {string} classes
   */
  removeClass(classes) {
    if (typeof classes === "string") {
      let arrClass = classes.split(" ");

      for (let i in arrClass) {
        if (typeof arrClass[i] === "string") {
          this.classList.remove(arrClass[i].trim());
        }
      }
    }
    return this;
  },

  /**
   * Retira o obrigatório do campo
   */
  removeRequired(elem) {
    if (elem !== undefined) {
      elem.removeAttribute("data-required");
    } else {
      this.removeAttribute("data-required");
    }
    this.querySelector(".tooltip").remove();
    let label = this.parents(".fieldbox")[0].querySelector("label");
    if (label !== null) {
      label.removeClass("label-required");
    }
    return this;
  },

  /**
   * Define o campo como obrigatório
   */
  setRequired(elem) {
    if (elem !== undefined) {
      elem.setAttribute("data-required", true);
    } else {
      this.setAttribute("data-required", true);
    }

    let fieldbox = this.parents(".fieldbox");

    let label = this.parents(".fieldbox")[0].querySelector("label");
    if (label !== null && label.innerHTML.length > 0) {
      label.addClass("label-required");
    }

    return this;
  },

  setValue(value) {
    if (this.classList.contains("combo")) {
      const opts =
        document
          .querySelector(`[data-id="${this.dataset.opts}"]`)
          ?.querySelectorAll("div") || [];

      const exists = Array.from(opts).some((opt) => opt.dataset.value == value);
      if (exists) {
        const input = this.querySelector("input");
        input.value = value;

        const selector = this.querySelector(".combo-selected");
        selector.dataset.value = value;

        // Usa o texto da opção original, se quiser exibir o label real
        const opt = Array.from(opts).find((opt) => opt.dataset.value == value);
        selector.textContent = opt?.textContent ?? value;
      }
    } else {
      this.value = value;
    }
  },

  /**
   * Exibe o elemento
   */
  show() {
    this.style.display = "block";
    return this;
  },

  /**
   * Define um texto para o elemento
   *
   * @param {string} [text] Conteúdo do elemento
   * @returns {string} Conteúdo do elemento
   */
  text(text) {
    if (typeof text === "string" || typeof text === "number") {
      this.innerText = text;
      return this;
    } else if (typeof text === "undefined") {
      return this.innerText;
    } else {
      return this;
    }
  },

  /**
   * Cria um tooltip para o elemento
   *
   * @param {string} text
   * @param {string} [position="top"] ( top | right | bottom | left )
   * @param {string} [color="yellow"] ( black | blue | cyan | gray | green | red | silver | yellow | white )
   */
  tooltip(html, position = "right", autoClose = true) {
    if (typeof html !== "string") {
      return;
    }

    let positions = ["top", "right", "bottom", "left"];
    if (!positions.includes(position)) {
      position = "right";
    }

    let rcpt;

    if (this.tagName.toUpperCase() === "INPUT") {
      if (this.type === "checkbox" || this.type === "radio") {
        rcpt = this.nextSibling;
      } else {
        rcpt = this;
      }
    } else {
      rcpt = this;
    }

    rcpt.classList.add("tooltip-gate");
    // rcpt.setAttribute('tooltip-gate', seq);

    let tooltip = document.createElement("span");
    tooltip.innerHTML = html;
    tooltip.classList.add("tooltip");
    tooltip.setAttribute("data-position", position);
    document.body.append(tooltip);

    rcpt.addEventListener("mouseover", () => {
      if (tooltip.offsetWidth > 0) {
        let coord = rcpt.getBoundingClientRect();

        switch (position) {
          case "left":
            tooltip.style.left = coord.left - tooltip.offsetWidth + "px";
            tooltip.style.top =
              coord.top + (coord.height - tooltip.offsetHeight) / 2 + "px";
            break;
          case "right":
            tooltip.style.left = coord.right + 7 + "px";
            tooltip.style.top =
              coord.top + (coord.height - tooltip.offsetHeight) / 2 + "px";
            break;
          case "top":
            tooltip.style.top = coord.top - tooltip.offsetHeight + "px";
            tooltip.style.left =
              coord.left + (coord.width - tooltip.offsetWidth) / 2 + "px";
            break;
          case "bottom":
            tooltip.style.top = coord.bottom + 7 + "px";
            tooltip.style.left =
              coord.left + (coord.width - tooltip.offsetWidth) / 2 + "px";
            break;
        }
        tooltip.classList.add("tooltip-show");
      }
    });

    if (autoClose !== false) {
      rcpt.addEventListener("mouseout", () => {
        tooltip.classList.remove("tooltip-show");
      });
    } else {
      let span = document.createElement("span");
      span.classList.add("tooltip-close");
      span.classList.add("fa-solid");
      span.classList.add("fa-times");
      span.addEventListener("click", () => {
        tooltip.classList.remove("tooltip-show");
      });
      tooltip.append(span);
    }

    return this;
  },

  /**
   * Define a largura de um elemento
   *
   * @param {(string | number)} [width] Largura do elemento
   * @returns {any} Largura em pixels do elemento
   */
  width(width) {
    if (typeof width === "string") {
      this.style.width = width;
      return this;
    } else if (typeof width === "number") {
      this.style.width = `${parseInt(width)}px`;
      return this;
    } else if (typeof width === "undefined") {
      return this.clientWidth;
    }
  },
};

const dialogRegionOriginalState = new WeakMap();
const dialogScopeOriginalOverflow = new WeakMap();

/** Reaplica o bloqueio modal à região permitida pelo Dialog mais alto. */
const refreshDialogInteractionLock = () => {
  if (typeof document === 'undefined') return;
  const dialogs = Array.from(document.querySelectorAll('.dialog.show'));
  const topDialog = dialogs.reduce((top, dialog) => (
    !top || Number(dialog.style.zIndex) > Number(top.style.zIndex) ? dialog : top
  ), null);
  const allowedRegions = new Set(topDialog?._overlayScope?.regions || []);
  const applicationModal = topDialog?._overlayScope?.name === 'application';
  const regions = Array.from(document.querySelectorAll('[data-ep-shell-region]'));

  regions.forEach((region) => {
    if (!dialogRegionOriginalState.has(region)) {
      dialogRegionOriginalState.set(region, region.inert === true);
    }
    // O backdrop ja bloqueia o workspace. Nao inativar cabecalho, navegacao e rodape fora dele.
    region.inert = applicationModal ? !allowedRegions.has(region) : dialogRegionOriginalState.get(region);
  });

  const lockedOwners = new Set(dialogs.map((dialog) => dialog._overlayScope?.container).filter(Boolean));
  const previousOwners = Array.from(document.querySelectorAll('[data-ep-dialog-scroll-lock]'));
  previousOwners.forEach((owner) => {
    const original = dialogScopeOriginalOverflow.get(owner);
    if (!lockedOwners.has(owner)) {
      owner.style.overflow = original ?? '';
      owner.removeAttribute('data-ep-dialog-scroll-lock');
    }
  });
  lockedOwners.forEach((owner) => {
    if (owner === document.documentElement) return;
    if (!dialogScopeOriginalOverflow.has(owner)) {
      dialogScopeOriginalOverflow.set(owner, owner.style.overflow);
    }
    owner.dataset.epDialogScrollLock = 'true';
    owner.style.overflow = 'hidden';
  });
};

const extendHTMLElement = () => {
  for (let prop in htmlElement) {
    if (htmlElement.hasOwnProperty(prop)) {
      HTMLElement.prototype[prop] = function (...args) {
        return htmlElement[prop].apply(this, args);
      };
    }
  }
};

export default extendHTMLElement;
